module.exports = __webpack_public_path__ + "static/card-education-programs-4-d23161df033fbebad3cd39f6d77fc0c3.jpg";